// index.sp.js（SP用・既存spBaseを使用）
import { initSpBase } from "./base/spBase.js";
import { revealSection, revealOnLoad, revealSequence } from "./core/fade.js";
import { initCareerAccordion } from "./features/accordion.js";

document.addEventListener("DOMContentLoaded", () => {
  initSpBase();
  revealOnLoad(".js-fv .reveal", { base: 0.2, step: 0.06 });
  revealSection(".reveal");
  revealSequence(".js-stagger", ".reveal", { rootMargin: "0% 0% -12% 0", threshold: 0 }, { base: 0, step: 0.08 });
  initCareerAccordion();
});
